export default __webpack_public_path__ + "static/media/start_early.52fd797e.png";